module.exports = __webpack_public_path__ + "img/7_pc.536b7232.gif";